export default __webpack_public_path__ + "static/media/1.812f45f8.png";